import React from "react";
import LegalText from "@components/LegalText";
import { LEGAL_TEXT_TYPES } from "../../../constants/legalText.const";

const InformationText = () => {
  return (
    <div className="card border-0 shadow-sm rounded-4 mb-4">
      <div className="card-body p-4 p-md-5">
        <h5 className="card-title fw-bold mb-4">Ticari Elektronik İleti İzni</h5>
        <div className="agreement-content p-3 bg-light rounded-3">
          <LegalText
            type={LEGAL_TEXT_TYPES.TICARI_ELEKTRONIK_ILETI_IZNI}
            className=""
          />
        </div>
      </div>
    </div>
  );
};

export default InformationText;
